<div class="breadcrumb-and-current-day">
  <mwo-breadcrumb (click)="handleBreadcrumbClick()" class="edit-scheduler-page-breadcrumb"
                  title="{{ 'planning.schedule' | translate }}"></mwo-breadcrumb>
  <label class="current-day">{{ (activeDay$ | async) | translate }}</label>
</div>
